import { Modal } from '../ui/Modal';
import type { DemCloudTalkLog } from '../../types/dem';
import {
  agentStatusLabel,
  agentStatusTone,
  formatCloudTalkLogTime,
} from '../../lib/demCloudTalk';

type CloudTalkActivityLogModalProps = {
  logs: DemCloudTalkLog[];
  open: boolean;
  loading: boolean;
  error: string | null;
  onClose: () => void;
};

function StatusCell({
  status,
  emphasize = false,
}: {
  status: string;
  emphasize?: boolean;
}) {
  const tone = agentStatusTone(status);
  return (
    <span
      className={`dem-cloudtalk-log-status dem-cloudtalk-log-status--${tone}${
        emphasize ? ' dem-cloudtalk-log-status--new' : ''
      }`}
    >
      {agentStatusLabel(status)}
    </span>
  );
}

export function CloudTalkActivityLogModal({
  logs,
  open,
  loading,
  error,
  onClose,
}: CloudTalkActivityLogModalProps) {
  return (
    <Modal open={open} onClose={onClose} title="Agent activity logs" wide>
      <p className="page-lead dem-cloudtalk-logs-lead">
        Latest 20 status changes (SGT). Full history: Settings → Activity log.
      </p>

      {error && <p className="alert alert-error">{error}</p>}

      {loading ? (
        <p className="dem-cloudtalk-empty">Loading activity logs…</p>
      ) : logs.length === 0 ? (
        <p className="dem-cloudtalk-empty">No activity logs found.</p>
      ) : (
        <div className="dem-cloudtalk-logs-table">
          <div className="dem-cloudtalk-logs-table__head" aria-hidden>
            <span>Timestamp (SGT)</span>
            <span>Agent</span>
            <span>Previous</span>
            <span>New status</span>
          </div>
          {logs.map((log) => (
            <div key={log.log_id || `${log.time}|${log.agent}`} className="dem-cloudtalk-logs-row">
              <span className="dem-cloudtalk-logs-row__time">{formatCloudTalkLogTime(log.time)}</span>
              <span className="dem-cloudtalk-logs-row__agent">{log.agent}</span>
              <StatusCell status={log.old_status} />
              <StatusCell status={log.new_status} emphasize />
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
}
